/* eslint no-console:0 */

import React, { Suspense } from 'react'
import * as ActionCable from '@rails/actioncable'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import RestfulClient from 'restful-json-api-client'
import * as Sentry from "@sentry/browser";

import 'bootstrap/dist/js/bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'

// Import SCSS through Vite for HMR support
import '../stylesheets/application.bootstrap.scss'

import { i18nInitPromise } from '../src/config/i18n'
import AppRouter from '../src/AppRouter'
import configureStore from '../src/config/stores'
import getRailsEnv from '../src/utils/railsEnv'

import 'moment/min/moment-with-locales'

const { persistor, store } = configureStore()

RestfulClient.configure({
  headers: {
    'X-CSRF-Token': () => document.querySelector('[name="csrf-token"]')?.content
  },
  requestCredentials: 'same-origin'
})

if (import.meta.env.JAVASCRIT_BEACON_DSN) {
  const beaconUrl = new URL(import.meta.env.JAVASCRIT_BEACON_DSN).origin

  fetch(beaconUrl, { mode: 'no-cors', signal: AbortSignal.timeout(300) })
    .then(() => {
      const VERSION = document.querySelector('meta[name="app-version"]')?.content

      Sentry.init({
        dsn: import.meta.env.JAVASCRIT_BEACON_DSN,
        environment: getRailsEnv(),
        release: `linguiini@${VERSION}`
      })
    })
    .catch(() => {}) // Beacon not running, skip silently
}

ActionCable.logger.enabled = import.meta.env.DEV

document.addEventListener('DOMContentLoaded', () => {
  i18nInitPromise.then(() => {
    const container = document.getElementById('app')
    const root = createRoot(container)
    root.render(
      <Suspense fallback={<div>Loading...</div>}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppRouter />
          </PersistGate>
        </Provider>
      </Suspense>
    )
  })
})
